import React, { useState, useContext, useEffect } from 'react'
import { Grid, Typography, FormControl, InputLabel, TextField } from '@material-ui/core'
import { UserContext } from './../../../utils/UserContext'
import { Context } from '../../../Store'
import { useTranslation } from 'react-i18next'

export const PhoneNumber = () => {
    const [state, dispatch] = useContext(Context)
    const { user, _ } = useContext(UserContext)
    const [phoneNumber, setPhoneNumber] = useState(state?.phone_number)
    const { t } = useTranslation()

    useEffect(() => {
      setPhoneNumber(user.phone_no)
    }, [])
  
  return (
    <Grid item xs={12} lg={11}>
      <Typography variant="body1">{t('number.phone')}</Typography>
      <FormControl fullWidth variant="outlined">
        <TextField
          name="phone_number"
          value={phoneNumber}
          fullWidth
          variant='outlined'
          disabled={true}
        />
      </FormControl>
    </Grid>
  )
}